export const OBJECTIVE_PRACTICE_REPORTS_LOADING_STATE = 'report/OBJECTIVE_PRACTICE_REPORTS_LOADING_STATE';

export const GET_OBJECTIVE_PRACTICE_REPORTS = 'report/GET_OBJECTIVE_PRACTICE_REPORTS';
export const GET_OBJECTIVE_PRACTICE_REPORTS_SUCCESS = 'report/GET_OBJECTIVE_PRACTICE_REPORTS_SUCCESS';
export const GET_OBJECTIVE_PRACTICE_REPORTS_ERROR = 'report/GET_OBJECTIVE_PRACTICE_REPORTS_ERROR';

export const TEAMS_ACCOUNTABILITY_SCORE_LOADING_STATE = 'report/TEAMS_ACCOUNTABILITY_SCORE_LOADING_STATE';
export const GET_TEAMS_ACCOUNTABILITY_SCORE = 'report/GET_TEAMS_ACCOUNTABILITY_SCORE';
export const GET_TEAMS_ACCOUNTABILITY_SCORE_SUCCESS = 'report/GET_TEAMS_ACCOUNTABILITY_SCORE_SUCCESS';
